import styled from '@emotion/styled';
import React, { MutableRefObject, ReactNode } from 'react';
import { useResizeHeight } from '../../../../utils/hooks/useResizeHeight';
import { breakpoints, colors, NAVBAR_HEIGHT_S, spacing } from '../../../../utils/styleguide';

type ContainerProps = {
  isOpened?: boolean;
  height?: number;
};

const Container = styled.div`
  position: absolute;
  top: ${NAVBAR_HEIGHT_S - 1}px;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  background: ${colors.white};
  transform: ${({ isOpened }: ContainerProps) =>
    isOpened ? 'translateX(0)' : 'translateX(-100%)'};
  transition: transform 0.3s ease-in-out;
  height: ${({ height }: ContainerProps) =>
    height ? `calc(${height - NAVBAR_HEIGHT_S + 4}px)` : `calc(100vh - ${NAVBAR_HEIGHT_S - 80}px)`};
  width: 100%;
  padding: ${spacing[3]}px ${spacing[4]}px ${spacing[3]}px;
  overflow-y: scroll;

  ${breakpoints.tablet} {
    width: 380px;
  }
`;

type MobileNavBarWrapperProps = {
  isOpened?: boolean;
  children: ReactNode;
  ref?: MutableRefObject<HTMLDivElement | null>;
  className?: string;
};

const MobileNavBarWrapper = React.forwardRef<HTMLDivElement, MobileNavBarWrapperProps>(
  function MobileNavBarWrapper({ isOpened, children, className }, ref) {
    const height = useResizeHeight();
    return (
      <Container
        data-testid="mobilenavbarwrapper"
        isOpened={isOpened}
        ref={ref}
        className={className}
        height={height}
      >
        {children}
      </Container>
    );
  },
);

export default MobileNavBarWrapper;
